// extracted by mini-css-extract-plugin
module.exports = {"ImagePreview":"ImagePreview_ImagePreview__34j-M","ImagePreviewFullscreen":"ImagePreview_ImagePreviewFullscreen__jnxoa"};